
define('template!preconfItemsKanbanViewTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="content">\n  <div class="well preconf-items-container kanban-board kanban-board-preconf-item">\n    <h2>' +
((__t = ( _.i18n('menu.preconf-items.Management') )) == null ? '' : __t) +
'</h2>\n    <div class="sub-caccounts-table">\n      <div class="form-group add-new-block">\n        <a target="_self" class="btn new-button add-btn-text">\n          <i class="mdi-content-add"></i>\n          <span>' +
((__t = ( _.i18n('preconf-items.new') )) == null ? '' : __t) +
'</span>\n        </a>\n        ';
 if (!design2) { ;
__p += '\n        <a class="download preconf-items-export btn-link" href="">\n          <i class="mdi-file-file-download alligned-middle"></i>\n          <span class="action-label alligned-middle">' +
((__t = ( _.i18n("common.download") )) == null ? '' : __t) +
'</span>\n        </a>\n        <a class="download pdf-download" href="" download></a>\n        ';
 } ;
__p += '\n        <div class="js-action-buttons-region preconf-items-action-button f-r"></div>\n      </div>\n    </div>\n    <div id="preconf-items-filters-region"></div>\n    <div id="preconf-items-board-region"></div>\n  </div>\n</div>';

}
return __p
};});

